module.exports = __webpack_public_path__ + "static/media/sistemaPegar4.1401d796.jpg";